<div class="ouraEntrance">
  <div class="ouraEntrance__imageSection">
    <div class="ouraEntrance__imageWrapper">
      <div class="ellipse ellipse__topRight"></div>
      <div class="ellipse ellipse__bottomLeft"></div>
      <img
        class="ouraEntrance__image"
        src="https://www.datocms-assets.com/21281/1744292200-iphone15-oura-gen4-img.png"
        alt="Oura ring gen 4 and iPhone 15"
      />
    </div>
  </div>
  <div class="ouraEntrance__content">
    <h1 class="ouraEntrance__title">NC° Powered by Oura</h1>
    <p class="ouraEntrance__subtitle">
      Take control of your fertility today with Natural Cycles powered by Oura
    </p>

    <app-button
      uid="ouraEntrance__already-using-oura-btn"
      class="ouraEntrance__button"
      color="shimmer-gradient"
      text="purple"
      (click)="showOuraRegistrationModal()"
      [label]="'Unlock exclusive offer'"
    />
  </div>
</div>
